import React from 'react';
import {Route, Switch} from 'react-router-dom';
import MeusEventos from './pages/MeusEventos';

import './assets/meus-eventos.scss';

const MeusEventosPage: React.FC = () => {
  return (
    <>
      <Switch>
        <Route path="/meus-eventos/inicio" exact={true} component={MeusEventos}/>
      </Switch>
    </>
  );
};
export default MeusEventosPage;
